import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { LegalShell, LegalLead } from './LegalPages';

/**
 * 特定商取引法に基づく表記 — the Act on Specified Commercial Transactions
 * disclosure that is legally required of any operator selling paid services
 * to customers in Japan. Entity-specific fields (seller, manager, address,
 * phone) are owner-fill placeholders until the registered operating company
 * is provisioned — see the operator note at the bottom.
 */
export function TokushohoPage() {
  const { t } = useTranslation();

  const rows: Array<{ label: string; value: React.ReactNode }> = [
    { label: t('tokusho.seller_label'), value: t('tokusho.seller_value') },
    { label: t('tokusho.manager_label'), value: t('tokusho.manager_value') },
    { label: t('tokusho.address_label'), value: t('tokusho.address_value') },
    { label: t('tokusho.phone_label'), value: t('tokusho.phone_value') },
    {
      label: t('tokusho.email_label'),
      value: <code className="font-mono text-ink-900">{t('tokusho.email_value')}</code>,
    },
    {
      label: t('tokusho.url_label'),
      value: (
        <a
          href={t('tokusho.url_value')}
          className="text-accent-700 hover:text-accent-600 underline underline-offset-2"
        >
          {t('tokusho.url_value')}
        </a>
      ),
    },
    {
      label: t('tokusho.price_label'),
      value: (
        <>
          {t('tokusho.price_value')}{' '}
          <Link to="/pricing" className="text-accent-700 hover:text-accent-600 underline underline-offset-2">
            /pricing
          </Link>
        </>
      ),
    },
    { label: t('tokusho.extra_fees_label'), value: t('tokusho.extra_fees_value') },
    { label: t('tokusho.payment_method_label'), value: t('tokusho.payment_method_value') },
    { label: t('tokusho.payment_timing_label'), value: t('tokusho.payment_timing_value') },
    { label: t('tokusho.delivery_label'), value: t('tokusho.delivery_value') },
    { label: t('tokusho.cancel_label'), value: t('tokusho.cancel_value') },
    { label: t('tokusho.environment_label'), value: t('tokusho.environment_value') },
    { label: t('tokusho.special_label'), value: t('tokusho.special_value') },
  ];

  return (
    <LegalShell titleKey="tokusho.title">
      <LegalLead>{t('tokusho.lead')}</LegalLead>

      <div className="mt-6 overflow-x-auto border border-ink-200">
        <table className="w-full text-[13px] border-collapse">
          <tbody>
            {rows.map((r) => (
              <tr key={r.label} className="border-b border-ink-200 last:border-b-0 align-top">
                <th
                  scope="row"
                  className="w-1/3 min-w-[10rem] bg-ink-50 px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-ink-600"
                >
                  {r.label}
                </th>
                <td className="px-4 py-3 text-ink-700 leading-relaxed">{r.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="mt-8 rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-[13px] text-amber-800">
        {t('tokusho.owner_note')}
      </p>
    </LegalShell>
  );
}
